import {
  CUSTOMER_PRIORITY_LIST_REQUEST,
  CUSTOMER_PRIORITY_LIST_SUCCESS,
  CUSTOMER_PRIORITY_LIST_FAILED,
  CUSTOMER_PRIORITY_IMPORT_REQUEST,
  CUSTOMER_PRIORITY_IMPORT_SUCCESS,
  CUSTOMER_PRIORITY_IMPORT_FAILED,
  CUSTOMER_PRIORITY_REMOVE_REQUEST,
  CUSTOMER_PRIORITY_REMOVE_SUCCESS,
  CUSTOMER_PRIORITY_REMOVE_FAILED,
  CUSTOMER_PRIORITY_STATE_CHANGE
} from "../../../_utils/constants/CustomerPriority";

const initialState = {
  priorityList: [],
  isLoading: false,
  isImported: false,
  isRemoved: false,
  importResult: null,
  errors: {},
};

const CustomerPriorityReducer = (state = initialState, action) => {
  switch (action.type) {
    case CUSTOMER_PRIORITY_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
        errors: {}
      }
    case CUSTOMER_PRIORITY_LIST_SUCCESS:
      var decryptedData = action.payload;
      return {
        ...state,
        priorityList: decryptedData.result,
        isLoading: false,
        errors: {}
      }
    case CUSTOMER_PRIORITY_LIST_FAILED:
      return {
        ...state,
        isLoading: false,
        errors: action.payload
      }
    case CUSTOMER_PRIORITY_IMPORT_REQUEST:
      return {
        ...state,
        isLoading: true,
        isImported: false,
        importResult: null,
        errors: {}
      }
    case CUSTOMER_PRIORITY_IMPORT_SUCCESS:
      var decryptedData = action.payload;
      return {
        ...state,
        isLoading: false,
        isImported: true,
        importResult: decryptedData.result,
        errors: {}
      }
    case CUSTOMER_PRIORITY_IMPORT_FAILED:
      return {
        ...state,
        isLoading: false,
        isImported: false,
        importResult: null,
        errors: action.payload
      }
    case CUSTOMER_PRIORITY_REMOVE_REQUEST:
      return {
        ...state,
        isLoading: true,
        isRemoved: false,
        errors: {}
      }
    case CUSTOMER_PRIORITY_REMOVE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isRemoved: true,
        errors: {}
      }
    case CUSTOMER_PRIORITY_REMOVE_FAILED:
      return {
        ...state,
        isLoading: false,
        isRemoved: false,
        errors: action.payload
      }
    case CUSTOMER_PRIORITY_STATE_CHANGE:
      return {
        ...state,
        isImported: false,
        isRemoved: false,
        importResult: null,
      }
    default:
      return state;
  }
}

export default CustomerPriorityReducer;
